import ApiService from "../ApiService";

const cityService = {
    getCities() {
        return ApiService.get(`/city`);
    },

    createProvider(formData) {
        return ApiService.post("/city/save", formData);
    },

    updateCities(id, cityData) {
        return ApiService.put("/city/" + id, cityData);
    },
    deleteCities(formData) {
        return ApiService.post(`/city/remove/`, formData);
    }
};

export default cityService;